import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StoriesAdd } from '../../assets/images';
import { initialNameHandle } from '../../Helpers/Chat/User';
import { getThumbBase64URL, getTimeAgo } from '../../Helpers/Utility';
import { setMyStories } from '../../slice/storiesSlice';
import SDK from '../SDK';
import ProfileImage from '../WebChat/Common/ProfileImage';
import { getFromLocalStorageAndDecrypt } from '../WebChat/WebChatEncryptDecrypt';
import logger from '../../Helpers/logger';

const PAGE_SIZE = 20;

const MyStories = ({ openGallery, handleShowStoryPreview }) => {
    const dispatch = useDispatch();

    const [isFetching, setIsFetching] = useState(false);

    const myStories = useSelector(state => state.stories.myStories);

    const vCardData = useSelector(state => state.vCardData.data);

    const token = getFromLocalStorageAndDecrypt('token');

    const imageToken = vCardData?.thumbImage && vCardData?.thumbImage !== '' ? vCardData?.thumbImage : vCardData?.image;

    const iniTail = initialNameHandle(vCardData);

    const fetchMtStories = async (currentPage = 0) => {
        if (isFetching) return;
        setIsFetching(true);

        try {
            const response = await SDK.fetchMyStories({
                page: currentPage,
                limit: PAGE_SIZE,
            });

            const { data = [] } = response.data;

            const updatedMyStories = currentPage === 0 ? data : [...(myStories || []), ...data];
            dispatch(setMyStories(updatedMyStories));
        } catch (err) {
            logger.error('Failed to fetch my stories:', err);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        fetchMtStories(0);
    }, []);

    const hasStories = myStories.length > 0;

    if (!hasStories) {
        return (
            <li className="stories-list-li my-stories" role="button" tabIndex={0} onClick={openGallery}>
                <div className="image-overlay">
                    <ProfileImage chatType={'chat'} userToken={token} imageToken={imageToken} name={iniTail} />
                    <i className="add-stories">
                        <StoriesAdd />
                    </i>
                </div>
                <div className="stories-details">
                    <h3 className="userName">{'My Status'}</h3>
                    <span className="content">{'Tap to add status update'}</span>
                </div>
            </li>
        );
    }

    return myStories.map((item, index) => {
        const latestStory = item.stories?.at(-1) ?? null;

        return (
            <li
                className="stories-list-li my-stories"
                role="button"
                tabIndex={0}
                key={index}
                onClick={() => {
                    handleShowStoryPreview(item);
                }}
            >
                <div className="image active">
                    <img src={getThumbBase64URL(latestStory?.thumbImage)} alt="MyStories" />
                </div>
                <div className="stories-details">
                    <h3 className="userName">{'My Status'}</h3>
                    <span className="content">{getTimeAgo(item?.lastUpdatedAt)}</span>
                </div>
            </li>
        );
    });
};

export default MyStories;
